import { render, staticRenderFns } from "./TableListClients.vue?vue&type=template&id=3261247c&"
import script from "./TableListClients.vue?vue&type=script&lang=js&"
export * from "./TableListClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3261247c')) {
      api.createRecord('3261247c', component.options)
    } else {
      api.reload('3261247c', component.options)
    }
    module.hot.accept("./TableListClients.vue?vue&type=template&id=3261247c&", function () {
      api.rerender('3261247c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/supplier/TableListClients.vue"
export default component.exports